module.exports = __webpack_public_path__ + "media/images/states/ga-0b0c61d9c698f18324356f876f14603b.png";